import React, { useEffect, useState } from "react";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import { useAuth } from "../../contexts/AuthContext";
import { roles } from "../../firebase.collection";
import NotesTabTherapistMobile from "../Notes/NotesTabTherapistMobile";
import NotesTabNonTherapistMobile from "../Notes/NotesTabNonTherapistMobile";
import NotesTabTherapistForMedicalStaffMobile from "../Notes/NotesTabTherapistForMedicalStaffMobile";
import NotesTabTherapistForHospitalityMobile from "../Notes/NotesTabTherapistForHospitalityMobile";

function ClientNotesMobile(props) {
  //VARIABLES

  const { currentUser } = useAuth();
  const userIdState = currentUser ? currentUser.uid : "";

  //STATES
  const [userRole, setUserRole] = useState("");

  //FUNCTIONS

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    );
  }

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  return (
    <div className="tab-container-white-mobile2">
      {(() => {
        if (
          userRole === "Therapist" ||
          userRole === "Super Admin" ||
          userRole === "Clinical Director"
        ) {
          return <NotesTabTherapistMobile {...props} />;
        } else if (userRole === "Medical Staff") {
          return <NotesTabTherapistForMedicalStaffMobile {...props} />;
        } else if (userRole === "Hospitality Staff") {
          return <NotesTabTherapistForHospitalityMobile {...props} />;
        } else {
          return <NotesTabNonTherapistMobile {...props} />;
        }
      })()}
    </div>
  );
}

export default ClientNotesMobile;
